import { render, staticRenderFns } from "./Planet.vue?vue&type=template&id=09b9ab36&"
import script from "./Planet.vue?vue&type=script&lang=js&"
export * from "./Planet.vue?vue&type=script&lang=js&"
import style0 from "./Planet.vue?vue&type=style&index=0&id=09b9ab36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports